import { defineMessages } from "react-intl";

const namespace = `membershipCardRequest`;
const membershipCardRequest = defineMessages({
  lang: {
    id: `${namespace}.lang`,
    description: "Language Field",
    defaultMessage: "Language"
  },
  title: {
    id: `${namespace}.title`,
    description: "Page Title",
    defaultMessage: "Request your Evo Membership Card"
  },
  description: {
    id: `${namespace}.description`,
    description: "Page Description",
    defaultMessage: `As part of our sustainability efforts, Evo Membership cards are only sent on request. If you need to access cars without the app, request a card here (note that your Evo Membership card won’t work on bikes or scooters).`
  },
  successMessage: {
    id: `${namespace}.successMessage`,
    description: "Success Message",
    defaultMessage: `Success!`
  },
  successMessageDescription: {
    id: `${namespace}.successMessageDescription`,
    description: "Success Message Description",
    defaultMessage: `Your Evo Membership card is on the way! Just give us 5-7 days to get it to you.`
  }
});

export default membershipCardRequest;
